/**
 * Label Position enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum LABEL_POSITION {
	LEFT = "left",
	TOP = "top"
}

export type LABEL_POSITION_string = keyof typeof LABEL_POSITION;

export const LABEL_POSITION_default: LABEL_POSITION_string = "TOP";
